import React from 'react'
import { Modal } from 'antd'
import { Table } from 'react-bootstrap'
import styled from 'styled-components'
import { APISTATIC_HOST } from '../../../conf/hosts'

export type ModalType = 'rules' | 'key'

export interface IRulesKeyModalProps {
  type?: ModalType
  close: () => void
}

const RuleList = styled.ol`
  li {
    margin-bottom: 20px;
  }
`

const KeyTable = styled(Table)`
  td {
    font-size: 1.2rem;
    font-weight: bold;
    font-family: "Roboto Mono", monospace;
  }
`

const rules = (
  <RuleList>
    <li>
      When certain Roman numerals are listed more than once, you figure out what number the Roman numeral represents, and you add them together.<br /> 
      <em>For example, II = 1 + 1 = 2, or XX = 10 + 10 = 20, or, XXX = 10 + 10 + 10 = 30.</em>          
    </li>
    <li>
      Roman numerals can NOT come together more than 3 times. <br />
      <em>For example, we cannot write 40 as XXXX</em> 
    </li>
    <li>
      Only I, X, and C can be used to subtract numerals. There can be 6 combinations when we subtract.<br /> 
      <em>These include:</em><br /> 
      <em>IV = 5 - 1 = 4</em><br />
      <em>IX = 10 - 1 = 9</em><br />
      <em>XL = 50 - 10 = 40</em><br />
      <em>XC = 100 - 10 = 90</em><br />
      <em>CD = 500 - 100 = 400</em><br />
      <em>CM = 1000 - 100 = 900</em><br />
    </li>
    <li>
      When a Roman numeral is placed <strong>before</strong> another Roman numeral that is a higher number, then you would subtract the second numeral with the first numeral. <br />
      <em>For example, IV = 5 - 1 = 4, or, XL = 50 - 10 = 40, or XC = 100 - 10 = 90</em>
    </li>
    <li>
      When a Roman numeral is placed <strong>after</strong> another Roman numeral that is a higher number, then you would add the two numerals together.<br /> 
      <em>For example, VIII = 5 + 1 + 1 + 1 = 8, XV = 10 + 5 = 15</em>
    </li>
    <li>
      When a lower Roman numeral is placed between two higher numerals, it is subtracted from the numeral on its right. <br />
      <em>For example, XIV = 10 + (5 - 1) = 14, or, XIX = 10 + (10 - 1) = 19 </em>
    </li>
    <li>
      The letters V, L, and D are not repeated.
    </li>
    <li>
      To multiply a number by a factor of 1000 a bar is placed over it.
    </li>
    <li>
      There is no Roman numeral for zero (0).
    </li>
  </RuleList>
)

const key = (
  <KeyTable striped responsive>
    <tbody>
      <tr>
        <td>I = 1</td>
        <td>V = 5</td>
      </tr>
      <tr>
        <td>X = 10</td>
        <td>L = 50</td>
      </tr>
      <tr>
        <td>C = 100</td>
        <td>D = 500</td>
      </tr>
      <tr>
        <td>M = 1000</td>
        <td></td>
      </tr>
    </tbody>
  </KeyTable>
)

const RulesKeyModal = ({ type, close }: IRulesKeyModalProps) => {

  const title = type === 'rules' ? 'Rules' : 'Key'

  const downloadLink = `${APISTATIC_HOST}exercises/pdf/RomanNumeralsKeyRules.pdf` 

  return (
    <Modal
      title={<h4>{title}</h4>}
      visible={type !== undefined}
      onCancel={close}
      footer={null}
      width={800}
    >
      {type === 'rules' ? rules : key}
      <p><a href={downloadLink} target='_blank' rel='noreferrer'><strong>Download Key and Rules as PDF</strong></a></p>
    </Modal>
  )
}

export default RulesKeyModal